module.exports = __webpack_public_path__ + "static/img/Easy to Understand Reports.7ea3ed7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Easy to Understand Reports.png
// module id = Zm3I
// module chunks = 1